import { MapPin, Church, MoonStar, Flower2 } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "@/components/Reveal";

const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Banigb%C3%A9-Gare%2C+Ifangni%2C+B%C3%A9nin";

const DAYS = [
  {
    icon: MoonStar,
    day: "Jeudi 10 Septembre 2026",
    summary: "Première veillée de prières et de chants",
    details:
      "À partir de 19h00 — Veillée de prières, témoignages et chants traditionnels au domicile familial de Banigbé-Gare.",
  },
  {
    icon: Flower2,
    day: "Vendredi 11 Septembre 2026",
    summary: "Retrait de corps, exposition & veillée",
    details:
      "15h00 — Retrait de la dépouille à la Morgue PROCI. 17h00 — Arrivée et exposition du corps au domicile TANDJIEKPON. 20h00 — Grande veillée mortuaire et chants d'hommage.",
  },
  {
    icon: Church,
    day: "Samedi 12 Septembre 2026",
    summary: "Culte d'inhumation, caveau familial & réception",
    details:
      "09h00 — Culte d'inhumation à l'Église Catholique Jean-Baptiste de Banigbé-Gare. 11h30 — Inhumation dans le caveau familial. 13h00 — Réception des collectivités alliées et rafraîchissements.",
  },
];

export default function Program() {
  return (
    <section
      id="programme"
      data-testid="program-section"
      className="bg-[#F4EFEA]/90 px-4 py-16 sm:py-24"
    >
      <div className="mx-auto max-w-3xl">
        <Reveal className="mb-10 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.3em] text-[#C85A32]">
            Banigbé-Gare — Commune d'Ifangni
          </p>
          <h2 className="mt-3 font-display text-3xl font-semibold text-stone-900 sm:text-4xl">
            Programme des Obsèques
          </h2>
          <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-stone-500 sm:text-base">
            Du jeudi 10 au samedi 12 Septembre 2026.
          </p>
        </Reveal>

        <Reveal>
          <div className="rounded-3xl border border-stone-200/80 bg-white/90 p-4 shadow-sm sm:p-6">
            <Accordion type="single" collapsible defaultValue="day-0">
              {DAYS.map((d, i) => (
                <AccordionItem key={d.day} value={`day-${i}`} className="border-stone-200/70">
                  <AccordionTrigger
                    data-testid={`accordion-day-${i + 1}`}
                    className="px-2 py-4 text-left hover:no-underline sm:px-4"
                  >
                    <span className="flex items-center gap-3 sm:gap-4">
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#C5A059]/15 text-[#C5A059]">
                        <d.icon className="h-5 w-5" />
                      </span>
                      <span>
                        <span className="block font-display text-lg font-semibold text-stone-900 sm:text-xl">
                          {d.day}
                        </span>
                        <span className="block text-xs text-stone-500 sm:text-sm">
                          {d.summary}
                        </span>
                      </span>
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="px-2 pb-5 pl-[64px] text-sm leading-relaxed text-stone-600 sm:px-4 sm:pl-[72px] sm:text-base">
                    {d.details}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>

        <Reveal className="mt-8 text-center">
          <a
            data-testid="maps-button"
            href={MAPS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-[#C5A059] px-7 py-3 text-xs font-semibold uppercase tracking-[0.15em] text-[#8a6b2e] transition-colors duration-300 hover:bg-[#C5A059] hover:text-white"
          >
            <MapPin className="h-4 w-4" />
            Voir l'itinéraire vers Banigbé-Gare
          </a>
        </Reveal>
      </div>
    </section>
  );
}
